// Card photo `sizes` per layout (tailwind `tablet` 620px, `desktop` 1200px). The card is a
// third of the row from tablet up: a viewport-wide value made the browser pick a 2-3x wider file.
// Plain module (no 'use client'): server components such as VillaCarousel read it too
export const VILLA_CARD_IMAGE_SIZES = {
  // Listing grid: 1 column, then 3 columns from `tablet`
  grid: '(min-width: 620px) 33vw, 100vw',
  // Listing with the map: list next to a map twice its width from `desktop`, alone below
  withMap: '(min-width: 1200px) 33vw, 100vw',
  // Featured villas slider: 3 slides, 2 up to 1200px, 1 up to 767px (react-slick
  // breakpoints are max-width, inclusive)
  featured: '(min-width: 1201px) 33vw, (min-width: 768px) 50vw, 100vw',
  // Discover pages slider: 3 slides, 2 up to 1200px, 1 up to 640px
  discover: '(min-width: 1201px) 33vw, (min-width: 641px) 50vw, 100vw',
} as const;

export type VillaCardImageSizes =
  (typeof VILLA_CARD_IMAGE_SIZES)[keyof typeof VILLA_CARD_IMAGE_SIZES];
